// The one sign-in guard for app pages (every page inside AppLayout).

export interface SessionState {
  /** The session check hasn't answered yet. */
  loading: boolean;
  signedIn?: boolean;
}

/** Wait while the session check runs (no flash for signed-in users), then render or send to sign-in. */
export function sessionGate(state: SessionState): "wait" | "render" | "redirect" {
  if (state.loading) return "wait";
  return state.signedIn ? "render" : "redirect";
}

/**
 * Where to send a signed-out visitor: the language's sign-in page, with the
 * page they wanted as `next` (Auth only follows same-site paths).
 */
export function signInPath(language: string, pathname: string, search = ""): string {
  const lang = ["cs", "en"].includes(language) ? language : "cs";
  const target = `${pathname}${search}`;
  const isAuth = /^\/(cs|en)\/auth(\/|$)/.test(pathname);
  return !isAuth && target.startsWith("/") && !target.startsWith("//")
    ? `/${lang}/auth?next=${encodeURIComponent(target)}`
    : `/${lang}/auth`;
}
